import InviraUserForm from './InviraUserForm.vue'
export {InviraUserForm}
export default InviraUserForm

